import * as tslib_1 from "tslib";
import { Observable } from "rxjs";
import { RestServiceConstants } from "../../constants/rest-service.constants";
import { RestClient } from "../rest/client/rest.client";
import { ResponseBody } from "../rest/decorators/response-body.decorator";
import { Response } from "../rest/decorators/response.decorator";
import { RequestBody, Query } from "../rest/request/params";
import { Headers } from "../rest/decorators/headers.decorator";
import { GET, POST } from "../rest/request/methods";
import { DMVConstants } from "../../constants/dmv.constants";
import { StringUtil } from "../../utils/string.util";
import { AppConfigUtil } from "../../utils/app-config.util";
import { HttpResponse } from "@angular/common/http";
import { ErrorLogRequest } from "src/app/models/dmv/models";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DMVDataService extends RestClient {
    getRegistration(pin, dateOfBirth, licensePlate, expirationDate, pageSize, targetPageNumber, qrCode, token) {
        return;
    }
    getRegistrationResponse(agencyID, pin, dateOfBirth, licensePlate, expirationDate, pageSize, targetPageNumber, sessionID, qrCode, token) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.REGISTRATION_URI, agencyID, sessionID));
        return this.getRegistration(pin, dateOfBirth, licensePlate, expirationDate, pageSize, targetPageNumber, qrCode, token);
    }
    getAgencyConfig() {
        return;
    }
    getAgencyConfigResponse(agencyID, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.AGENCY_CONFIGURATION_URI, agencyID, sessionID));
        return this.getAgencyConfig();
    }
    getDmvCost(newTagCode, renewalOptionID) {
        return;
    }
    getDmvCostResponse(newTagCode, renewalOptionID, agencyID, registrationID, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.DMV_COST_URI, agencyID, registrationID, sessionID));
        return this.getDmvCost(newTagCode, renewalOptionID);
    }
    getDonationOrgs() {
        return;
    }
    getDonationOrgsResponse(sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.DONATION_ORGS_URI, sessionID));
        return this.getDonationOrgs();
    }
    getRegistrationTypes() {
        return;
    }
    getRegistrationTypesResponse(sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.REGISTRATION_TYPES_URI, sessionID));
        return this.getRegistrationTypes();
    }
    getRegistrationCost(registrationType, renewalOptionID) {
        return;
    }
    getRegistrationCostResponse(agencyID, sessionID, registrationType, renewalOptionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.DUPLICATE_REGISTRATION, agencyID, sessionID, "0"));
        return this.getRegistrationCost(registrationType, renewalOptionID);
    }
    getTagCatalog() {
        return;
    }
    getTagCatalogResponse(sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.TAG_CATALOG_URI, sessionID));
        return this.getTagCatalog();
    }
    // @GET()
    // @ResponseBody<any>()
    // public getRenewal(
    // @Query("renewalToken") renewalToken?: string,
    // @Query("renewalItems") renewalItems?: Array<RenewalItem>,
    // @Query("donations") donations?: Array<Donation>,
    // @Query("megAppFee") megAppFee?: number,
    // @Query("megAppFeeAbsorbed") megAppFeeAbsorbed?: boolean,
    // @Query("serviceProviderFee") serviceProviderFee?: number,
    // @Query("deliveryMethod") deliveryMethod?: Renewal.DeliveryMethodEnum,
    // @Query("pickupLocationID") pickupLocationID?: string,
    // @Query("pickupPersonName") pickupPersonName?: string,
    // @Query("mailToAddress") mailToAddress?: Address,
    // @Query("updateAddressOnFile") updateAddressOnFile?: boolean,
    // @Query("fundingToken") fundingToken?: string,
    // @Query("notificationOptions") notificationOptions?: NotificationOptions,
    // @Query("comment") comment?: string
    // ): Observable<any> {
    // 	return;
    // }
    // public getRenewalResponse(request:Renewal, agencyID): Observable<RenewalResponse> {
    // 	this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
    // 	this.setDynamicUri(
    // 		StringUtil.format(DMVConstants.RENEWAL, agencyID)
    // 	);
    // 	return this.getRenewal(
    // 	request.renewalToken,
    // 	request.renewalItems,
    // 	request.donations,
    // 	request.megAppFee,
    // 	request.megAppFeeAbsorbed,
    // 	request.serviceProviderFee,
    // 	request.deliveryMethod,
    // 	request.pickupLocationID,
    // 	request.pickupPersonName,
    // 	request.mailToAddress,
    // 	request.updateAddressOnFile,
    // 	request.fundingToken,
    // 	request.notificationOptions,
    // 	request.comment
    // 	);
    // }
    getFundingToken(request, webComponentLoadTime, webComponentTokenizationTime) {
        return;
    }
    getFundingTokenResponse(request, agencyID, sessionID, webComponentLoadTime, webComponentTokenizationTime) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.FUNDING_TOKEN, agencyID, sessionID));
        return this.getFundingToken(request, webComponentLoadTime, webComponentTokenizationTime);
    }
    getPaymentAccessToken() {
        return;
    }
    getPaymentAccessTokenResponse(agencyID, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.PAYMENT_ACCESS_TOKEN, agencyID, sessionID));
        return this.getPaymentAccessToken();
    }
    postError(request) {
        return;
    }
    postErrorResponse(request, agencyID, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.ERROR, agencyID, sessionID));
        return this.postError(request);
    }
    getRenewal(request) {
        return;
    }
    getRenewalResponse(request, agencyID, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.RENEWAL, agencyID, sessionID));
        return this.getRenewal(request);
    }
    updateRenewal(request) {
        return;
    }
    getUpdatedRenewalResponse(request, agencyID, renewToken, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.UPDATE_RENEWAL, agencyID, renewToken, sessionID));
        return this.updateRenewal(request);
    }
    getServiceFees() {
        return;
    }
    getServiceFeesResponse(renewalToken, agencyID, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.SERVICE_FEE_AMOUNT, agencyID, renewalToken, sessionID));
        return this.getServiceFees();
    }
    getRenewalSubmit() {
        return;
    }
    getRenewalSubmitResponse(renewalToken, agencyID, sessionID) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.RENEWAL_SUBMIT, agencyID, renewalToken, sessionID));
        return this.getRenewalSubmit();
    }
    postErrorLog(request) {
        return;
    }
    postErrorLogRequest(request) {
        this.setDynamicTimeout(AppConfigUtil.getProperties().timeOut);
        this.setDynamicUri(StringUtil.format(DMVConstants.ERROR_LOG, request.agencyID, request.sessionID));
        return this.postErrorLog(request.errorDescription);
    }
}
DMVDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DMVDataService_Factory() { return new DMVDataService(i0.ɵɵinject(i1.HttpClient)); }, token: DMVDataService, providedIn: "root" });
tslib_1.__decorate([
    Headers({
        Accept: RestServiceConstants.APPLICATION_JSON,
        "content-type": RestServiceConstants.APPLICATION_JSON
    }),
    GET(),
    ResponseBody(),
    tslib_1.__param(0, Query("pin")),
    tslib_1.__param(1, Query("dateOfBirth")),
    tslib_1.__param(2, Query("licensePlate")),
    tslib_1.__param(3, Query("expirationDate")),
    tslib_1.__param(4, Query("pageSize")),
    tslib_1.__param(5, Query("targetPageNumber")),
    tslib_1.__param(6, Query("qrCode")),
    tslib_1.__param(7, Query("token")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String, String, String, Number, Number, Boolean, String]),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getRegistration", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getAgencyConfig", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__param(0, Query("newTagCode")),
    tslib_1.__param(1, Query("renewalOptionID")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Number]),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getDmvCost", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getDonationOrgs", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getRegistrationTypes", null);
tslib_1.__decorate([
    GET(),
    Response(),
    tslib_1.__param(0, Query("registrationType")),
    tslib_1.__param(1, Query("renewalOptionID")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Number]),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getRegistrationCost", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getTagCatalog", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__param(1, Query("webComponentLoadTime")),
    tslib_1.__param(2, Query("webComponentTokenizationTime")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Number, Number]),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getFundingToken", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getPaymentAccessToken", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "postError", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getRenewal", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "updateRenewal", null);
tslib_1.__decorate([
    GET(),
    ResponseBody(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getServiceFees", null);
tslib_1.__decorate([
    POST(),
    Response(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "getRenewalSubmit", null);
tslib_1.__decorate([
    POST(),
    ResponseBody(),
    tslib_1.__param(0, RequestBody),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Observable)
], DMVDataService.prototype, "postErrorLog", null);
